define.alias("ember-svg-jar/helpers/svg-jar", "calendar/helpers/svg-jar");